export default __webpack_public_path__ + "static/media/placeholder.ea87cfce.webp";